import { formatPercent } from 'helpers/money'

import { getNumber } from './getNumber'

const formatValue = (value: string | number): string => formatPercent(getNumber(value) / 100, 2, true, true)

export { formatValue }
